import React, { useEffect, useState } from "react";
import CircularProgress from '@material-ui/core/CircularProgress';
import Skeleton from '@material-ui/lab/Skeleton';
import { CustomizedProgressBars } from './roundedProgress';
import Button from '@material-ui/core/Button';
import Oxygen from '../../img/dashboard_icons/blood-oxygen.png'
import BPicon from '../../img/dashboard_icons/BPicon.svg'
import Stepsicon from '../../img/dashboard_icons/footstepsicon.svg'
import BloodGlucose from '../../img/dashboard_icons/Blood-Glucose.svg'
import CaloriesBurnt from '../../img/dashboard_icons/CaloriesBurnt.svg'
import OxygenIcon from '../../img/oxygen-icon.svg';
import WeightIcon from '../../img/weight-icon.png';
import HeightIcon from '../../img/height-icon.svg'
import SleepIcon from '../../img/sleep-icon.svg';
import StandIcon from '../../img/stand-icon.svg';
import CycleIcon from '../../img/cycle-icon.svg';
import ExcerciseIcon from '../../img/excercise-icon.svg';
import RestingIcon from '../../img/resting-icon.svg';
import SwimmingIcon from '../../img/swiming-icon.svg';
import BodyTempIcon from '../../img/body-temp-icon.svg';
import BodyMassIndexIcon from '../../img/body-mass-index.svg';
import HeartIcon from '../../img/heart-icon.svg';
import WalkAndRunIcon from '../../img/walk-run-icon.svg';
import Stairs from '../../img/steps-icon.svg';

import { LocalizationAPiCall } from '../../common/apiconfig'
// import { jwt } from '../../common/jwtAuthentication';
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
const activityIconMap = {
  BloodPressureCount: BPicon,
  BloodGulcoseCount: BloodGlucose,
  HeartCount: HeartIcon,
  Weight: WeightIcon,
  CaloriesCount: CaloriesBurnt,
  Height: HeightIcon,
  Bodytemperature: BodyTempIcon,
  StepsCount: Stepsicon,
  OxegenCount: OxygenIcon,
  ExerciseMinutes: ExcerciseIcon,
  RunningWalking: WalkAndRunIcon,
  SleepCount: SleepIcon,
  RestingHR: RestingIcon,
  BreathingRate: RestingIcon,
  BodyMass: WeightIcon,
  Floors: Stairs,
  CyclingDistance: CycleIcon,
  SwimmingDistance: SwimmingIcon,
  StandHours: StandIcon,
  ExerciseDistance: ExcerciseIcon,
  BodyMassIndex:BodyMassIndexIcon
  // Add more mappings as needed
};
const typeLabelMap = {
  BloodPressureCount: "Blood Pressure",
  BloodGulcoseCount: "Blood Glucose",
  HeartCount: "Heart rate",
  Weight: "Weight",
  CaloriesCount: "Calories burnt",
  Height: "Height",
  PeakFlow: "Peak flow",
  Bodytemperature: "Temperature",
  StepsCount: "Steps",
  OxegenCount: "Blood oxygen",
  ExerciseMinutes: "Exercise minutes",
  RunningWalking: "Distance",
  SleepCount: "Sleep",
  RestingHR: "Resting HR",
  BreathingRate: "Breathing rate",
  BodyMass: "Body mass index",
  Floors: "Stairs climbed",
  CyclingDistance: "Cycling Distance",
  SwimmingDistance: "Swimming Distance",
  StandHours: "Stand Hours",
  ExerciseDistance: "Exercise Distance",
  BodyMassIndex:'Body Mass Index'
};

function PhysicalActivity(props) {
  const [offset, setoffset] = useState(0);
  const [progress, setProgress] = useState(false);
  const [valSearch, setValSearch] = useState('');
  const colorPalette = ['#59c265', '#02dadb', '#46a3df', '#e74b83'];

  const isLoading = !props.activityList || props.activityList.length === 0;

  const renderSkeletons = () => {
    return Array.from({ length: 4 }).map((_, index) => (
      <div key={index} className="col-6 justify-content-center customizedprogressbar" style={{ marginBottom: '1rem' }}>
        <Skeleton variant="circle" width={100} height={100} />
        <div className="d-flex justify-content-center align-items-center mt-2">
          <Skeleton variant="rect" width={60} height={20} />
        </div>
      </div>
    ));
  };

  return (
    <>
      {progress && (
        <div className="fullScreen">
          <CircularProgress
            disableShrink
            className="progressCircle"
            value={90}
            size={100}
            thickness={1.5}
          />
        </div>
      )}
      <div className="height100">
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <h6 className="text-nowrap">
            {props.langData?.length > 0
              ? props.langData.find(item => item.keyword === "daily_activities_lbl")?.[props.lang]
              : ""}
          </h6>
          <div className="text-nowrap">
            <h6>
              <a href="/patient/dailyActivities" style={{fontSize:'14px'}}>All</a>
              <span className="right pl-1 primary" style={{fontSize:'13px'}}>
                <i className="fa fa-chevron-right text-primary" aria-hidden="true"></i>
              </span>
            </h6>
          </div>
        </div>

        <section className="height100 d-flex flex-column justify-content-center iconstyle">
          <section className="row justify-content-center circular mt2rem">
            {props.activityList.length > 0 ? (
              isLoading ? (
                renderSkeletons()
              ) : (
                props.activityList.map((item, index) => {
                  const icon = activityIconMap[item.type];
                  const label = typeLabelMap[item.type];
                  const randomColor = colorPalette[index % colorPalette.length];
                  return (
                    <div
                      key={index}
                      className="col-6 justify-content-center customizedprogressbar"
                      style={{ marginBottom: '1rem' }}
                    >
                      <CustomizedProgressBars
                        size={100}
                        value={100}
                        color={randomColor}
                        display={item.value ?? 0}
                        unit={item.unit}
                      />
                      <div className="d-flex justify-content-center align-items-center">
                        <div className="label">
                          <img src={icon} alt={item.type} height={30} width={30} />
                          <br />
                          <span className="label text-nowrap">{label}</span>
                        </div>
                      </div>
                    </div>
                  );
                })
              )
            ) : (
              Object.keys(activityIconMap)
                .filter(type => type !== 'HeartCount' && type !== 'StepsCount')
                .slice(0, 4)
                .map((type, index) => {
                  const icon = activityIconMap[type];
                  const label = typeLabelMap[type];
                  const randomColor = colorPalette[index % colorPalette.length];

                  return (
                    <div
                      key={index}
                      className="col-6 justify-content-center customizedprogressbar"
                      style={{ marginBottom: '1rem' }}
                    >
                      <CustomizedProgressBars
                        size={100}
                        value={100}
                        color={randomColor}
                        display={0}
                        unit=""
                      />
                      <div className="d-flex justify-content-center align-items-center">
                        <div className="label">
                          <img src={icon} alt={type} height={30} width={30} />
                          <br />
                          <span className="label">{label}</span>
                        </div>
                      </div>
                    </div>
                  );
                })
            )}
                      </section>
        </section>
      </div>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    langData: state.langData,
    lang: state.lang,
    state
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    localizationdata: (data) => {
      return dispatch({
        type: 'localizationdata',
        value: data
      }
      )
    }
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PhysicalActivity));


